var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useGlobalContext, useHotelReviewsResults } from '@honeycomb/data';
import { Button, Clone, Divider, Stacker } from '@honeycomb/ui-core';
import { HotelCustomerReview } from '../../HotelCustomerReview';
export function HotelReviewsList(_a) {
    var _b;
    var { hotelDetails } = _a, other = __rest(_a, ["hotelDetails"]);
    const { resourceStrings: { HOTEL_REVIEW_SEEMOREREVIEWS }, } = useGlobalContext();
    const { estabId, customerFeedback } = hotelDetails;
    const [{ data: reviewData, loading: waitingForReviews }, fetchNextReviewsPage] = useHotelReviewsResults(estabId, 'GB');
    if (!customerFeedback) {
        return null;
    }
    const numberOfReviews = (customerFeedback === null || customerFeedback === void 0 ? void 0 : customerFeedback.numberOfReviews) || 0;
    const reviews = ((_b = reviewData === null || reviewData === void 0 ? void 0 : reviewData.getEstabById) === null || _b === void 0 ? void 0 : _b.reviews) || [];
    const hasMoreReviews = reviews.length > 0 && reviews.length < numberOfReviews;
    return (React.createElement(Stacker, Object.assign({ spacing: 5 }, other),
        reviews.map((review, index) => (React.createElement("div", { key: review.id },
            React.createElement(HotelCustomerReview, { review: review }),
            index < reviews.length - 1 && React.createElement(Divider, { mt: 5 })))),
        waitingForReviews && (React.createElement(Clone, { copies: 3 },
            React.createElement(HotelCustomerReview, { loading: true }))),
        !waitingForReviews && hasMoreReviews && (React.createElement(Button, { color: "primary", size: "m", variant: "outlined", fullWidth: true, onClick: fetchNextReviewsPage, loading: waitingForReviews, "data-id": "show-more-reviews" }, !waitingForReviews ? HOTEL_REVIEW_SEEMOREREVIEWS : ''))));
}
